
$( document ).ready(function() {

  $('.utiliseslider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow:3,
    slidesToScroll:1,
    autoplay: true,
    // centerMode:true,

    responsive: [
        {
            breakpoint:1200,
            settings: {
              slidesToShow:2,
              slidesToScroll:1,
              infinite: true,
              
            }
          },   
          {
            breakpoint:768,
            settings: {
              slidesToShow:1,
              slidesToScroll:1,
              infinite: true,
              
            }
          }    
      
      
      ]
    
    
});

 
var qtyy = parseInt($('.prdqn1').find('.quantity-input').val());
var qtyy2 = parseInt($('.prdqn2').find('.quantity-input').val());
if(!qtyy2){
      var c = qtyy;
    } else {
      var c = qtyy + qtyy2;
    }
  if(c == 0){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
    $(".AddToCart").prop("disabled",true);
   } else if(c == 1){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
    $(".AddToCart").prop("disabled",false);
   } else if(c == 2){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
    $(".AddToCart").prop("disabled",false);
   } else if(c == 3){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
    $(".AddToCart").prop("disabled",false);
   } else if(c == 4){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
    $(".AddToCart").prop("disabled",false);
   } else if(c == 5){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
    $(".AddToCart").prop("disabled",false);
   } else {
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
    $(".AddToCart").prop("disabled",false);
   }


$('.prdqn1 .btnqty').on('click', function(){
  var qtyy = parseInt($(this).parent('.prdqn1').find('.quantity-input').val());
    var qtyy2 = parseInt($('.prdqn2').find('.quantity-input').val());
    var qtyy3 = parseInt($('.prdqn3').find('.quantity-input').val());
    var qtyy4 = parseInt($('.prdqn4').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qtyy++;
  }else {
    if(qtyy > 0) {
      qtyy--;
    }
  }
  qtyy = (isNaN(qtyy))?0:qtyy;
    
  $(this).parent('.prdqn1').find('.quantity-input').attr("value",qtyy);


  if(!qtyy2){

    if(!qtyy3){

      if(!qtyy4){

        var c = qtyy;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
  } else {


      if(!qtyy3){

      if(!qtyy4){

        var c = qtyy + qtyy2;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy2 + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
    
  }
  

});



$('.prdqn2 .btnqty').on('click', function(){
  var qtyy = parseInt($(this).parent('.prdqn2').find('.quantity-input').val());
    var qtyy2 = parseInt($('.prdqn1').find('.quantity-input').val());
    var qtyy3 = parseInt($('.prdqn3').find('.quantity-input').val());
    var qtyy4 = parseInt($('.prdqn4').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qtyy++;
  }else {
    if(qtyy > 0) {
      qtyy--;
    }
  }
  qtyy = (isNaN(qtyy))?0:qtyy;
    
  $(this).parent('.prdqn2').find('.quantity-input').attr("value",qtyy);


  if(!qtyy2){

    if(!qtyy3){

      if(!qtyy4){

        var c = qtyy;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
  } else {


      if(!qtyy3){

      if(!qtyy4){

        var c = qtyy + qtyy2;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy2 + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
    
  }
  

});  


  $('.prdqn3 .btnqty').on('click', function(){
  var qtyy = parseInt($(this).parent('.prdqn3').find('.quantity-input').val());
    var qtyy2 = parseInt($('.prdqn2').find('.quantity-input').val());
    var qtyy3 = parseInt($('.prdqn1').find('.quantity-input').val());
    var qtyy4 = parseInt($('.prdqn4').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qtyy++;
  }else {
    if(qtyy > 0) {
      qtyy--;
    }
  }
  qtyy = (isNaN(qtyy))?0:qtyy;
    
  $(this).parent('.prdqn3').find('.quantity-input').attr("value",qtyy);


  if(!qtyy2){

    if(!qtyy3){

      if(!qtyy4){

        var c = qtyy;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
  } else {


      if(!qtyy3){

      if(!qtyy4){

        var c = qtyy + qtyy2;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy2 + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
    
  }
  

});


  $('.prdqn4 .btnqty').on('click', function(){
  var qtyy = parseInt($(this).parent('.prdqn4').find('.quantity-input').val());
    var qtyy2 = parseInt($('.prdqn1').find('.quantity-input').val());
    var qtyy3 = parseInt($('.prdqn2').find('.quantity-input').val());
    var qtyy4 = parseInt($('.prdqn3').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qtyy++;
  }else {
    if(qtyy > 0) {
      qtyy--;
    }
  }
  qtyy = (isNaN(qtyy))?0:qtyy;
    
  $(this).parent('.prdqn4').find('.quantity-input').attr("value",qtyy);


  if(!qtyy2){

    if(!qtyy3){

      if(!qtyy4){

        var c = qtyy;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
  } else {


      if(!qtyy3){

      if(!qtyy4){

        var c = qtyy + qtyy2;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
    
    } else {

      if(!qtyy4){

        var c = qtyy + qtyy2 + qtyy3;
            if(c == 0){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",true);
         }
            else if(c == 1){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 2){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 3){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 4){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 5){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 6){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 7){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 8){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 9){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else if(c == 10){
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         } else {
           $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
           $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
           $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
           $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
           $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
           $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
           $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
           $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
              $(".AddToCart").prop("disabled",false);
         }
    
      } else {

        var c = qtyy + qtyy2 + qtyy3 + qtyy4;
        if(c == 0){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",true);
       }
        else if(c == 1){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 2){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 3){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 4){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
     } else if(c == 5){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 6){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 7){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 8){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 9){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else if(c == 10){
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       } else {
       $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
       $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
       $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
       $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
       $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
       $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
       $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
       $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
          $(".AddToCart").prop("disabled",false);
       }
        
      }
      
    }
    
    
  }
  

});

  


  /*$('.prdqn1 .btnqty').on('click', function(){
  var qtyy = parseInt($(this).parent('.prdqn1').find('.quantity-input').val());
    var qtyy2 = parseInt($('.prdqn2').find('.quantity-input').val());
    var qtyy3 = parseInt($('.prdqn3').find('.quantity-input').val());
    var qtyy4 = parseInt($('.prdqn4').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qtyy++;
  }else {
    if(qtyy > 0) {
      qtyy--;
    }
  }
  qtyy = (isNaN(qtyy))?0:qtyy;
    
  $(this).parent('.prdqn1').find('.quantity-input').attr("value",qtyy);

    if(!qtyy2){
      var c = qtyy;
      if(c == 0){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",true);
   }
      else if(c == 1){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 2){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 3){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 4){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 5){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 6){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 7){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 8){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 9){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 10){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else {
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   }
    } else {
      var c = qtyy + qtyy2;
      if(c == 0){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",true);
   }
      else if(c == 1){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 2){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 3){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 4){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 5){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 6){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 7){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 8){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 9){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 10){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else {
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   }
    }
    
}); 

$('.prdqn2 .btnqty').on('click', function(){
  var qtyy = parseInt($(this).parent('.prdqn2').find('.quantity-input').val());
    var qtyy2 = parseInt($('.prdqn1').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qtyy++;
  }else {
    if(qtyy > 0) {
      qtyy--;
    }
  }
  qtyy = (isNaN(qtyy))?1:qtyy;
    
  $(this).parent('.prdqn2').find('.quantity-input').attr("value",qtyy);

    if(!qtyy2){
      var c = qtyy;
      if(c == 0){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",true);
   }
      else if(c == 1){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 2){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 3){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 4){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 5){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 6){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 7){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 8){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 9){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 10){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else {
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   }
    } else {
      var c = qtyy + qtyy2;
      if(c == 0){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",true);
   }
      else if(c == 1){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 2){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 3){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").removeClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").removeClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 4){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 5){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").removeClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").removeClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 6){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 7){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").removeClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").removeClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 8){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 9){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").removeClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").removeClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else if(c == 10){
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   } else {
     $(".progresspack").find(".progressbox:nth-child(1) .progressvector").addClass("progressactiveone");
     $(".progresspack").find(".progressbox:nth-child(2) .progressvector").addClass("progressactivetwo");
     $(".progresspack").find(".progressbox:nth-child(3) .progressvector").addClass("progressactivethree");
     $(".progresspack").find(".progressbox:nth-child(4) .progressvector").addClass("progressactivefour");
     $(".progresspack").find(".progressbox:nth-child(1)").addClass("progress1");
     $(".progresspack").find(".progressbox:nth-child(2)").addClass("progress2");
     $(".progresspack").find(".progressbox:nth-child(3)").addClass("progress3");
     $(".progresspack").find(".progressbox:nth-child(4)").addClass("progress4");
        $(".AddToCart").prop("disabled",false);
   }
    }
    
}); 
*/


      $('.AddToCart').on('click', function (e) {

		e.preventDefault();
        var currentElement = $(this);
        var itemsArray = [];
    
        var value1 = $(".var1").attr("data-id");
        var value2 = $(".var2").attr("data-id");
        var value3 = $(".var3").attr("data-id");
        var value4 = $(".var4").attr("data-id");

        if(value1){
          var qnt1 = $("#qnt1").val();
          var customItem1 = { id: value1, quantity: qnt1 };
          itemsArray.push(customItem1);
        }
        if(value2){
          var qnt2 = $("#qnt2").val();
          var customItem2 = { id: value2, quantity: qnt2 };
          itemsArray.push(customItem2);
        }
        if(value3){
          var qnt3 = $("#qnt3").val();
          var customItem3 = { id: value3, quantity: qnt3 };
          itemsArray.push(customItem3);
        }
        if(value4){
          var qnt4 = $("#qnt4").val();
          var customItem4 = { id: value4, quantity: qnt4 };
          itemsArray.push(customItem4);
        }

        

        /*if(!value1){
          var qnt = $("#qnt2").val();
          var customItem1 = { id: value2, quantity: qnt };
          itemsArray.push(customItem1);
        } else if(!value2) {
          var qnt = $("#qnt1").val();
          var customItem2 = { id: value1, quantity: qnt };
          itemsArray.push(customItem2);
        } else {
          var qnt1 = $("#qnt1").val();
          var qnt2 = $("#qnt2").val();
          var customItem3 = { id: value1, quantity: qnt1 };
          var customItem4 = { id: value2, quantity: qnt2 };
          itemsArray.push(customItem3);
          itemsArray.push(customItem4);
        }*/
        console.log(itemsArray);
        
        
    	$.ajax({
        	type: 'POST',
        	url: '/cart/add.js',
        	dataType: 'json',
        	data: { items: itemsArray },
        	success: function (success_data) {
            		$.ajax({
                    'url' : window.location.href,
                    'dataType' : 'html',
                    'method' : 'GET',
                    'success' : function(data) {
                      $("#mydiv").removeClass("is-empty");
                      $("#mydiv").addClass("active");
                      let form_markupp = $(data).find('#cart-icon-bubble').html();
                        $("#cart-icon-bubble").html(form_markupp);
                        let form_markup = $(data).find('.drawer__inner').html();
                        $(".drawer__inner").html(form_markup);
                    }
                });

        	},
        	error: function (data) {
            	alert(data.responseJSON.description);
        	}
    	});
        
  	});


});




   